// Packages
import PropTypes from 'prop-types'

// Components
import ManufacturerForm from 'modules/Manufacturers/components/Form';

// Other
import useApi from 'hooks/useApi';

const ManufacturerCreateScreen = ({ onClose, onSubmit, parent, parentId }) => {

    const { post: createItem, errors } = useApi('/manufacturers',  false)

	const submit = async (values) => {

        if( await createItem({[parent]: parentId, ...values}, 'Manufacturer created!') ) {
    
            onSubmit();
        }
    }


    return(
        <ManufacturerForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

ManufacturerCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ManufacturerCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default ManufacturerCreateScreen;